import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Option from '../../../components/Option';
import { Dropdown, DropdownOption } from '../../../components/Dropdown';
import './styles.css';

class LayoutComponent extends Component {
  static propTypes = {
    expanded: PropTypes.bool,
    onExpandEvent: PropTypes.func,
    doExpand: PropTypes.func,
    doCollapse: PropTypes.func,
    onChange: PropTypes.func,
    config: PropTypes.object,
    currentState: PropTypes.object,
    translations: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      blockTypes: this.getBlockTypes(props.translations),
    };
  }

  componentDidUpdate(prevProps) {
    const { translations } = this.props;
    if (translations !== prevProps.translations) {
      this.setState({
        blockTypes: this.getBlockTypes(translations),
      });
    }
  }

  getBlockTypes = (translations) => [
    {
      label: 'Code',
      displayName: translations['components.controls.blocktype.codeblock'],
    },
    {
      label: 'Blockquote',
      displayName: translations['components.controls.blocktype.blockquote'],
    },
  ];

  renderFlat(blocks) {
    const { config, onChange, currentState } = this.props;
    return (
      <div
        className={classNames('rdw-inline-wrapper', config.className)}
        aria-label="rdw-inline-control"
      >
        {config.options.map((style, index) => (
          <Option
            key={index}
            value={style}
            onClick={onChange}
            className={classNames(config[style].className)}
            active={
              currentState.blockType === style ||
              (style === 'MONOSPACE' && currentState.CODE)
            }
            title={config[style].title || blocks[index].displayName}
          >
            <img alt="" src={config[style].icon} />
          </Option>
        ))}
      </div>
    );
  }

  renderInDropdown(blocks) {
    const {
      config: { className, dropdownClassName, title },
      currentState: { blockType },
      expanded,
      doExpand,
      onExpandEvent,
      doCollapse,
      onChange,
      translations,
    } = this.props;
    const { blockTypes } = this.state;
    const currentBlockData = blockTypes.filter(
      (blk) => blk.label === blockType
    );
    const currentLabel =
      currentBlockData &&
      currentBlockData[0] &&
      currentBlockData[0].displayName;
    return (
      <div className="rdw-block-wrapper" aria-label="rdw-block-control">
        <Dropdown
          className={classNames('rdw-block-dropdown', className)}
          optionWrapperClassName={classNames(dropdownClassName)}
          onChange={onChange}
          expanded={expanded}
          doExpand={doExpand}
          doCollapse={doCollapse}
          onExpandEvent={onExpandEvent}
          title={
            title || translations['components.controls.blocktype.blocktype']
          }
        >
          <span>
            {currentLabel ||
              translations['components.controls.blocktype.blocktype']}
          </span>
          {blocks.map((block, index) => (
            <DropdownOption
              active={blockType === block.label}
              value={block.label}
              key={index}
            >
              {block.displayName}
            </DropdownOption>
          ))}
        </Dropdown>
      </div>
    );
  }

  render() {
    const { config } = this.props;
    const { inDropdown } = config;
    const { blockTypes } = this.state;
    const blocks = blockTypes.filter(
      ({ label }) => config.options.indexOf(label) > -1
    );
    return inDropdown ? this.renderInDropdown(blocks) : this.renderFlat(blocks);
  }
}

export default LayoutComponent;
